import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
    inputTxt: {
        width: '100%',
        margin: 5
    },
}))